import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import * as storeTypes from './root.store-types';

// Modules
import AuthModule from './modules/auth/auth.module';
import CompanyModule from './modules/company/company.module';
import JobTitleModule from './modules/company/modules/job-titles/job-title.module';
import UserModule from './modules/user/user.module';
import UserGroupModule from './modules/user/modules/user-groups/user-group.module';
import CategoryModule from './modules/category/category.module';
import DocumentModule from './modules/document/document.module';
import OvpModule from './modules/ovp/ovp.module';
import TemplateModule from './modules/template/template.module';
import ExportModule from './modules/exports/export.module';

export default new Vuex.Store({
    strict: true,
    state: {
        isLoading: true,
        alertData: {},
    },
    mutations: {
        [storeTypes.SET_IS_LOADING]: (state, isLoading) => state.isLoading = isLoading,
        [storeTypes.SET_ALERT_DATA]: (state, alertData) => state.alertData = alertData,
    },
    actions: {
        [storeTypes.ACTION_SET_IS_LOADING]: (store, isLoading) => store.commit(storeTypes.SET_IS_LOADING, isLoading),
    },
    getters: {
        [storeTypes.GET_IS_LOADING]: state => state.isLoading,
    },
    modules: {
        auth: AuthModule,
        company: CompanyModule,
        user: UserModule,
        category: CategoryModule,
        userGroup: UserGroupModule,
        document: DocumentModule,
        ovp: OvpModule,
        jobTitle: JobTitleModule,
        template: TemplateModule,
        export: ExportModule
    },
});